var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoRecording(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "#fc2125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3 5 C 1.897 5 1 5.897 1 7 L 1 18 C 1 19.103 1.897 20 3 20 L 21 20 C 22.103 20 23 19.103 23 18 L 23 7 C 23 5.897 22.103 5 21 5 L 3 5 z M 8 10 L 9 10 L 9.5 10 C 10.328 10 11 10.672 11 11.5 C 11 12.148 10.587719 12.694297 10.011719 12.904297 L 11.058594 15 L 9.9414062 15 L 9 13.117188 L 9 15 L 8 15 L 8 13 L 8 10 z M 12 10 L 15 10 L 15 11 L 13 11 L 13 12 L 14.599609 12 L 14.599609 13 L 13 13 L 13 14 L 15 14 L 15 15 L 12 15 L 12 10 z M 18 10 C 19.105 10 20 10.895 20 12 L 19 12 C 19 11.449 18.551 11 18 11 C 17.449 11 17 11.449 17 12 L 17 13 C 17 13.551 17.449 14 18 14 C 18.551 14 19 13.551 19 13 L 20 13 C 20 14.105 19.105 15 18 15 C 16.895 15 16 14.105 16 13 L 16 12 C 16 10.895 16.895 10 18 10 z M 5.5 11 C 6.328 11 7 11.672 7 12.5 C 7 13.328 6.328 14 5.5 14 C 4.672 14 4 13.328 4 12.5 C 4 11.672 4.672 11 5.5 11 z M 9 11 L 9 12 L 9.5 12 C 9.776 12 10 11.776 10 11.5 C 10 11.224 9.776 11 9.5 11 L 9 11 z",
    fill: "#fc2125"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoRecording);
export default __webpack_public_path__ + "static/media/video-recording.9efac472.svg";
export { ForwardRef as ReactComponent };